import { getDeviceType } from "common/utilities/ generic";
import { nextDayDate } from "common/utilities/date";
import { createPartnerCode, getQueryParams } from "common/utilities/queryparams";

export const setQuotePayload = (formData) => {
    const effectiveDate = nextDayDate(formData?.petModelLawConfig);

    const postData = {
        person: {
            email: formData.email,
        },
        houseHoldAttributes: {
            memberOfAnimalShelterHumaneSociety: false,
            isInMedicalServices: false,
            isMilitaryOrVeteran: false,
            isVetStaff: false,
        },
        pets: [
            {
                petName: formData.petName,
                dob: {
                    petAge: formData.petAge,
                },
                petType: formData.petType,
                breedId: formData.breedId,
                hasMicrochip: false,
                isWorkingDog: false,
                state: formData.state,
                zip: formData.zipCode,
                county: formData.countryCode,
                countryCode: formData.countryCode,
                quoteRequest: {
                    promoCode: formData?.promoCode,
                    discountType: "",
                    productId: "wellness",
                    effectiveDate: effectiveDate,
                },
            },
        ],
        optIn: formData.marketing,
        clearCart: true,
        pCode: createPartnerCode(formData.queryParams),
        metadata: {
            utmMedium: getQueryParams(formData.queryParams, "utm_medium"),
            utmSource: getQueryParams(formData.queryParams, "utm_source"),
            utmCampaign: getQueryParams(formData.queryParams, "utm_campaign"),
            deviceType: getDeviceType(),
            ipAddress: "",
            clientId: getQueryParams(formData.queryParams, "clientId"),
            subId: getQueryParams(formData.queryParams, "subid"),
        },
    };

    return postData;
};
